export const formatterSensor = (cell: any) => {
  const data = cell.getData();
  let license;
  switch (data?.type) {
    case 'type 1 License - 1 Year':
      license = `PW:T1_1_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 1 License - 2 Year':
      license = `PW:T1_2_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 1 License - 3 Year':
      license = `PW:T1_3_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 2 License - 1 Year':
      license = `PW:T2_1_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 2 License - 2 Year':
      license = `PW:T2_2_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 2 License - 3 Year':
      license = `PW:T2_3_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 3 License - 1 Year':
      license = `PW:T3_1_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 3 License - 2 Year':
      license = `PW:T3_2_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 3 License - 3 Year':
      license = `PW:T3_3_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 4 License - 1 Year':
      license = `PW:T4_1_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 4 License - 2 Year':
      license = `PW:T4_2_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 4 License - 3 Year':
      license = `PW:T4_3_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 1 License - Lifetime':
      license = `PW:T1_LF_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 2 License - Lifetime':
      license = `PW:T2_LF_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 3 License - Lifetime':
      license = `PW:T3_LF_${data?.id.toString().padStart(6, '0')}`;
      break;
    case 'type 4 License - Lifetime':
      license = `PW:T4_LF_${data?.id.toString().padStart(6, '0')}`;
      break;
  }

  return license;
};
